import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import { Dialog as MuiDialog } from '@mui/material';
import { useEffect } from 'react';
import DialogTitle from './DialogTitle.component';

const dialogCss = css`
  .MuiDialog-paper {
    overflow: initial;
  }
`;

/**
 * Renders a <Dialog /> component.
 * @param {object} props
 * @param {string} props.title
 * @param {strin} props.titleId
 * @param {boolean} props.show
 * @param {Array} props.children
 * @param {function} props.onClose
 * @param {number} props.maxWidth
 * @param {boolean} props.disableEscapeKeyDown
 * @param {string} props.disableCloseIcon
 * @returns {React.Component}
 */

export const Dialog = ({
  title = '',
  titleId = 'dialog-title',
  show,
  children,
  onClose = () => {},
  maxWidth = 'sm',
  disableEscapeKeyDown = false,
  disableCloseIcon = false,
  ...restProps
}) => {
  // to ensure A11y if enqueueSnackbar is invoked from open Dialog
  useEffect(() => {
    if (show) {
      const notistackRoot = document.getElementById('notistackHelper');
      notistackRoot?.setAttribute('aria-hidden', 'false');

      const root = document.getElementById('root');
      root?.setAttribute('aria-hidden', 'false');
    }
  }, [show]);
  return (
    <MuiDialog
      className="noTranslate"
      slotProps={{
        transition: {
          role: 'main',
        },
        paper: {
          sx: {
            width: {
              xs: '100%',
            },
            m: {
              xs: 0,
            },
          },
        },
      }}
      css={dialogCss}
      fullWidth
      maxWidth={maxWidth}
      onClose={(event, reason) => {
        if ((reason !== 'backdropClick') && onClose) {
          onClose(event, reason);
        }
      }}
      open={show}
      disableEscapeKeyDown={disableEscapeKeyDown}
      {...restProps}
    >
      {title && (
        <DialogTitle
          titleId={titleId}
          onClose={onClose}
          disableCloseIcon={disableCloseIcon}
        >
          {title}
        </DialogTitle>
      )}
      {children}
    </MuiDialog>
  );
};

Dialog.propTypes = {
  title: PropTypes.oneOfType(
    [PropTypes.node, PropTypes.string, PropTypes.number],
  ),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  titleId: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  maxWidth: PropTypes.string,
  disableEscapeKeyDown: PropTypes.bool,
  disableCloseIcon: PropTypes.bool,
};
